import { array, number, object, string } from 'yup';

import * as constants from '@/constants';
import i18n from '@/settings/i18n';
import { userSchema } from '@/services/validators/user';

export const subscriptionRequestSchema = object({
  serviceIds: array().min(1, i18n.t('ui.error.required.check')),
  adminIds: array().min(1, i18n.t('ui.error.required.check')),
  users: array().min(1, i18n.t('ui.error.required.input')).of(userSchema),
  billingContactId: number().when('projectClassId', {
    is: (projectClassId?: number) =>
      projectClassId === 0 || projectClassId === undefined,
    then: number().required(
      i18n.t('ui.subscription.error.billingContactId.blank'),
    ),
  }),
  billingNote: string()
    .nullable()
    .max(
      constants.BILLING_NOTE_LENGTH,
      i18n.t('ui.error.maxlength', { length: constants.BILLING_NOTE_LENGTH }),
    ),
  contactId: number().when('projectClassId', {
    is: (projectClassId?: number) =>
      projectClassId === 0 || projectClassId === undefined,
    then: number().required(i18n.t('ui.subscription.error.contactId.blank')),
  }),
  startsOn: string()
    .matches(constants.DATE_PATTERN, i18n.t('ui.error.invalidDate'))
    .required(i18n.t('ui.error.required.input')),
}).required();
